import React from 'react';
import IngredientWithAllergens from './IngredientWithAllergens';
import formats from '../../utils/formats';

export default function Ingredient(props) {
    const { ingredient, total, index } = props;

    return ingredient.has_allergens ?
        (<IngredientWithAllergens {...props}></IngredientWithAllergens>) :
        (<span className="ingredient mr-2">{formats.capitalize(ingredient.name)} {ingredient.bio && <span className="text-green-500">(bio)</span>}{(Boolean(Number(total - index - 1))) ? "," : null}</span>);
}
